import { useEffect, useState } from "react";
import Reports from "../components/reports";
import { READER_EFFICIENCY_REPORT_DATA } from "../constants/data.cnst";
import { TABLE_COLUMNS_CONFIG, type ColumnMeta } from "../constants/table.cnst";
import type { READER_EFFICIENCY_REPORT } from "../interfaces/dashboard";

export default function ReaderEfficiency() {
    const readerEfficiencyReportTableColumns: ColumnMeta[] = TABLE_COLUMNS_CONFIG.READER_EFFICIENCY_REPORT;

    const [readerEfficiencyReportTableData, setReaderEfficiencyReportTableData] = useState<READER_EFFICIENCY_REPORT[]>([]);

    useEffect(() => {
        setReaderEfficiencyReportTableData(READER_EFFICIENCY_REPORT_DATA)
    }, []);

    return (
        <Reports
        reportType="READER_EFFICENCY"
        tableColumns={readerEfficiencyReportTableColumns}
        tableData={readerEfficiencyReportTableData} />
    );
}